import React, { useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles (core, navigation optional)
import 'swiper/css';
import 'swiper/css/navigation'; // If you want navigation arrows
// import 'swiper/css/pagination'; // If you want pagination dots

// Import Swiper core and required modules
import { Navigation ,Autoplay/*, Pagination */ } from 'swiper/modules';

// Import the CSS module for styling
import styles from './css/TransformationSlider.module.css';


import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import styled from 'styled-components';

import Lottie from "lottie-react";
import { useTranslation } from 'react-i18next';
import bwsconfetti from "../lottiedata/bwsconfetti.json";



const Confetti= styled.div`
  width:90%;
  position: absolute;
    top: 20%;
    z-index: 100;
   
        height: 100%;
    scale: 2;
`;
// --- Placeholder Data ---
// Replace image URLs with your actual image paths or imports
const transformationData = [
  {
    id: 'today',
    index: 0,
    timelineLabel: 'Today',
    subtitle: 'Getting Started',
    imageUrl: 'https://builtwithscience.com/wp-content/uploads/2025/04/image_male1.png', // Replace with your image path
    bodyFat: '25%',
    experienceLevel: 'Beginner',
    description: 'Building the foundation – this is where your fitness journey begins!',
  },
  {
    id: 'may',
    index: 1,
    timelineLabel: 'May',
    subtitle: 'Seeing Changes', // Example subtitle
    imageUrl: 'https://builtwithscience.com/wp-content/uploads/2025/04/image_male2.png', // Replace with your image path
    bodyFat: '22%', // Example data
    experienceLevel: 'Novice', // Example data
    description: 'Momentum kicks in – your body starts to shift as healthy habits take root.', // Example data
  },
  {
    id: 'july',
    index: 2,
    timelineLabel: 'July',
    subtitle: 'Major Progress', // Example subtitle
    imageUrl: 'https://builtwithscience.com/wp-content/uploads/2025/04/image_male3.png', // Replace with your image path
    bodyFat: '18%', // Example data
    experienceLevel: 'Intermediate', // Example data
    description: 'Muscle definition is showing – you’re leaning out and staying consistent.', // Example data
  },
  {
    id: 'sept',
    index: 3,
    timelineLabel: 'Sept',
    subtitle: 'Goal Achieved', // Example subtitle
    imageUrl: 'https://builtwithscience.com/wp-content/uploads/2025/04/image_male4.png', // Replace with your image path
    bodyFat: '15%', // Example data
    experienceLevel: 'Advanced', // Example data
    description: 'Dialled in and athletic – your hard work is now fully visible!', // Example data
  },
];
// --- End Placeholder Data ---


function TransformationSlider(props) {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
   // console.log("ActiveIndex:",activeIndex);
   if (swiper.realIndex === last_index) {
    // Stop autoplay when reaching slide 3
    swiper.autoplay.stop();
    console.log("Autoplay stopped on slide 3");
  }
  };

  const sliderscount=props.sliderscount;
  
  let last_index=3;
  if(sliderscount === 3){
    last_index=2;
  }

  return (
    <div className={styles.container}>
    

      {/* Timeline */}
      <div className={styles.timelineContainer}>
        {props.transformationData.map((item, index) => (
          <React.Fragment key={item.id}>
            <div
              className={`${styles.timelineStep} ${
                index === activeIndex ? styles.activeStep : ''
              } ${index <= activeIndex ? styles.visitedStep : ''} ${ activeIndex  === last_index? styles.finnalStep : ''}`}
            >
              <div className={styles.timelineDot}></div>
              <div className={styles.timelineLabel}>{item.timelineLabel}</div>
              <div className={styles.timelineSubtitle}>{item.labelbodyfat}</div>
            </div>
            {/* Render line connecting dots except for the last one */}
            {index < transformationData.length - 1 && (
              <>
              <div
                className={`${sliderscount ===3 ? styles.timelineLine3: styles.timelineLine} ${
                  index < activeIndex ? styles.visitedLine : styles.nonvisitedLine
                }`} style={activeIndex === last_index? { width: `${(activeIndex ) * 25  }%` }: { width: `${(activeIndex ) * 25 +5 }%`  }}
              ></div>
              <div
              className={`${sliderscount ===3 ? styles.timelineLine3: styles.timelineLine} ${
                index < activeIndex ? styles.visitedLine : ''
              }`} 
            ></div>
            </>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Swiper Slider */}
      <div className={styles.swiperWrapper}>
         {/* Optional: Custom Left Arrow - Position outside Swiper */}
         { activeIndex === 0 ?   <button className={`${styles.navButtonNone} ${styles.navPrev}`} ></button>: <button className={`${styles.navButton} ${styles.navPrev}`} >
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <polyline points="15 18 9 12 15 6"></polyline>
</svg>
           </button> }

        <Swiper
          modules={[Navigation ,Autoplay/*, Pagination */]}
          spaceBetween={30} // Adjust spacing between slides
          
          autoplay={{ delay: 3000, disableOnInteraction: true ,stopOnLastSlide:true}}
         
          slidesPerView={0.8} // Show 1 full slide and parts of the next/prev
          centeredSlides={true} // Center the active slide
          navigation={{ // Use Swiper's built-in navigation (can be styled)
            nextEl: `.${styles.navNext}`, // CSS selector for next button
            prevEl: `.${styles.navPrev}`, // CSS selector for prev button (optional)
          }}
          // pagination={{ clickable: true }} // Optional pagination dots
          onSlideChange={handleSlideChange} // Update timeline on slide change
          className={styles.swiperContainer} // Custom class for the Swiper container
          // Allow touch control even if navigation buttons are outside
          allowTouchMove={true}
          loop={false}
        >
          {props.transformationData.map((item) => (
            <SwiperSlide key={item.id}  className={
              // Combine base class with conditional class
              `${styles.slide} ${activeIndex === last_index ? styles.finalSlideHighlight : ''} ${activeIndex === item.index ? styles.slideactive : styles.slidenoactive}`
              // ^^^ If activeIndex is 3, add the 'finalSlideHighlight' class
              //     Otherwise, add nothing extra ('')
            }  >
             { activeIndex=== last_index &&  item.index === last_index ? <Confetti>
               <Lottie autoplay loop={false} animationData={bwsconfetti}     />   
          { /*      <DotLottieReact
      src="https://lottie.host/6c6ffd8d-cdce-45f4-b5cc-506ecf4b6b61/9K0qJRIpdj.lottie"
      loop
      autoplay
    />
    */}
    </Confetti>  :'' }
              <div className={styles.slideContent}>
                <div className={styles.imageContainer}>
                   <img
                    src={item.imageUrl}
                    alt={t("results.transformation.imageAlt", { label: item.timelineLabel })}
                    className={styles.slideImage}
                  />
                   <span className={styles.bodyFatLabel}> {item.labelbodyfat}  {activeIndex === last_index ? <> <svg width="36" height="36" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.02305 3.01953H13.9273C14.0882 3.01953 14.2267 3.01953 14.3518 3.03473C14.8003 3.09058 15.2168 3.29582 15.5343 3.61736C15.8518 3.9389 16.0517 4.358 16.1019 4.80707H16.8222C17.0117 4.80529 17.4273 4.80171 17.7705 5.03141C18.2147 5.32725 18.3488 5.83581 18.3488 6.37118C18.3488 8.8076 17.0501 10.4343 15.3922 11.3379C14.4671 13.0217 12.7583 14.1917 10.9752 14.1917C9.61754 14.1917 8.32962 13.457 7.40277 12.4408C7.09481 12.1048 6.82447 11.7362 6.59659 11.3414C4.93954 10.4423 3.60156 8.81743 3.60156 6.37118C3.60156 5.83491 3.73563 5.32725 4.17894 5.03141C4.52304 4.80171 4.93865 4.80529 5.12812 4.80707H5.8485L5.85119 4.78205C5.90645 4.33788 6.10831 3.92484 6.4248 3.60834C6.7413 3.29185 7.15434 3.08999 7.59851 3.03473C7.72364 3.01953 7.86217 3.01953 8.02305 3.01953ZM7.17665 5.4774V5.48008L7.16771 8.6056V8.6065C7.16771 9.25091 7.35183 9.90962 7.67091 10.5129L7.68342 10.5353C7.87558 10.8946 8.116 11.2324 8.39397 11.5363C9.14652 12.3621 10.0993 12.851 10.9761 12.851C12.247 12.851 13.5868 11.9322 14.283 10.5773C14.5993 9.96812 14.7648 9.29197 14.7657 8.6056L14.7639 8.60382L14.7746 5.24234C14.7746 5.02605 14.7728 4.97868 14.7692 4.9474C14.7507 4.79954 14.6835 4.66206 14.5781 4.55669C14.4727 4.45132 14.3353 4.38407 14.1874 4.36555C14.0892 4.35971 13.9908 4.35792 13.8925 4.36019H8.0588C7.84162 4.36019 7.79514 4.36108 7.76386 4.36555C7.616 4.38407 7.47852 4.45132 7.37315 4.55669C7.26778 4.66206 7.20053 4.79954 7.18201 4.9474C7.17617 5.0456 7.17438 5.14399 7.17665 5.24234V5.4774ZM16.1126 6.14773L16.1045 8.6056V8.6065M16.084 9.08824C16.6542 8.40182 17.009 7.50627 17.009 6.37118C17.009 6.26571 17.0001 6.196 16.9921 6.1522C16.9233 6.14806 16.8544 6.14657 16.7856 6.14773H16.1126M5.84493 9.0364C5.83145 8.8932 5.82488 8.74944 5.82527 8.6056V8.60382L5.83331 6.14773H5.16566C5.06824 6.14773 5.00657 6.14773 4.9592 6.1522C4.94664 6.22449 4.94095 6.29781 4.94222 6.37118C4.94222 7.47677 5.289 8.35535 5.84493 9.0364ZM10.9752 14.6386C11.153 14.6386 11.3235 14.7092 11.4492 14.8349C11.5749 14.9606 11.6455 15.1311 11.6455 15.3089V17.3199H14.5503C14.728 17.3199 14.8985 17.3905 15.0243 17.5162C15.15 17.6419 15.2206 17.8124 15.2206 17.9902C15.2206 18.168 15.15 18.3385 15.0243 18.4642C14.8985 18.5899 14.728 18.6605 14.5503 18.6605H7.40009C7.22231 18.6605 7.05181 18.5899 6.9261 18.4642C6.80039 18.3385 6.72976 18.168 6.72976 17.9902C6.72976 17.8124 6.80039 17.6419 6.9261 17.5162C7.05181 17.3905 7.22231 17.3199 7.40009 17.3199H10.3049V15.3089C10.3049 15.1311 10.3755 14.9606 10.5012 14.8349C10.6269 14.7092 10.7974 14.6386 10.9752 14.6386Z" fill="white"/>
<path d="M10.7697 5.97327C10.7868 5.93297 10.8155 5.8986 10.852 5.87444C10.8886 5.85028 10.9314 5.8374 10.9752 5.8374C11.019 5.8374 11.0619 5.85028 11.0984 5.87444C11.135 5.8986 11.1636 5.93297 11.1808 5.97327L11.6322 7.05653C11.6479 7.09433 11.6737 7.12708 11.7068 7.1512C11.7399 7.17531 11.779 7.18987 11.8198 7.19327L12.9898 7.28712C13.0338 7.2906 13.0758 7.30705 13.1105 7.33437C13.1451 7.3617 13.1709 7.39868 13.1846 7.44066C13.1983 7.48263 13.1992 7.52772 13.1873 7.57022C13.1754 7.61273 13.1511 7.65075 13.1176 7.67948L12.2265 8.44276C12.1954 8.46957 12.1722 8.50444 12.1596 8.54354C12.147 8.58265 12.1454 8.62447 12.155 8.66442L12.4267 9.80487C12.4372 9.84791 12.4346 9.89309 12.4194 9.93468C12.4041 9.97626 12.3769 10.0124 12.341 10.0384C12.3052 10.0645 12.2625 10.0793 12.2182 10.081C12.1739 10.0827 12.1302 10.0712 12.0924 10.048L11.0914 9.43664C11.0564 9.41533 11.0162 9.40405 10.9752 9.40405C10.9342 9.40405 10.894 9.41533 10.859 9.43664L9.85802 10.048C9.8203 10.0712 9.77653 10.0827 9.73227 10.081C9.68801 10.0793 9.64525 10.0645 9.60943 10.0384C9.5736 10.0124 9.54633 9.97626 9.53108 9.93468C9.51582 9.89309 9.51327 9.84791 9.52375 9.80487L9.79635 8.66442C9.80596 8.62447 9.80437 8.58265 9.79176 8.54354C9.77914 8.50444 9.75599 8.46957 9.72484 8.44276L8.83286 7.67948C8.79904 7.65081 8.77452 7.61273 8.76241 7.57008C8.75029 7.52743 8.75114 7.48215 8.76485 7.43998C8.77855 7.39782 8.80449 7.36068 8.83936 7.3333C8.87423 7.30592 8.91646 7.28953 8.96067 7.28622L10.1297 7.19327C10.1707 7.19003 10.21 7.17554 10.2432 7.15142C10.2765 7.12729 10.3025 7.09446 10.3183 7.05653L10.7697 5.97327Z" fill="white"/>
</svg>  </> 
 :''}</span>
                </div>

                <div className={styles.detailsContainer}>
                  <div className={styles.detailsContainerInnerDiv}>
                    <div className={styles.detailsContainerInnerDivTex}>
                   </div>
                   </div>
                 {/* <div className={styles.progressBar}>
                     <div className={styles.progressInner} style={{ width: `${(activeIndex + 1) * 25}%` }}></div>
                   </div>
                   */}
                   <p className={styles.description}>{item.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Next Arrow - Position outside Swiper */}
        {/* This button's class name needs to match the one in Swiper's navigation config */}
        { activeIndex === last_index ?   <button className={`${styles.navButtonNone} ${styles.navNext}`} ></button>: 
        <button className={`${styles.navButton} ${styles.navNext}`}>
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>
        }
      </div>
    </div>
  );
}

export default TransformationSlider;